import React, { Component, Fragment } from 'react'
import { Paper, Grid, ListItem, Tooltip, withStyles } from '@material-ui/core'

// utils
import { convertToFixed, onChangeEditHOF, toPercentage } from '../../utils/common'
import { onKeyDown } from '../../utils/keycode'
import { EditableNumericInput, EditableSwitch } from '../common/EditableComponents'
import InfoIcon from '@material-ui/icons/Info'

export const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 300,
    fontSize: theme.typography.pxToRem(13),
    border: '2px solid #dadde9',
  },
}))(Tooltip)
export default class ExciseTaxOption extends Component {
  state = {
    excise: 'Excise Tax',
    nonCannabis: 'Non-cannabis Tax',
  }
  onChange = onChangeEditHOF(this.props.onChange)

  onChangeExcise = (key, isCheckBox) => async (e) => {
    const checked = e && e.target && e.target.checked
    if (key === 'enableExciseTax' && !checked) {
      await this.props.onChange('enableDeliveryFeeBeforeExciseTax', false)
      await this.props.onChange('enableSurchargeTaxExciseTax', false)
      await this.props.onChange('enableSurchargeFeeBeforeExciseTax', false)
    }
    if (key === 'nalExciseAfterCityTax' && !checked) {
      await this.props.onChange('enableDeliveryFeeBeforeExciseTax', false)
      await this.props.onChange('enableSurchargeFeeBeforeExciseTax', false)
    }

    this.props.onChange(key, checked)
  }

  onChangeExciseType = (key, value) => () => this.props.onChange(key, value)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  getValueToRender = (value, dependency = undefined) => {
    let valueResult = value
    if (dependency !== undefined) {
      valueResult = dependency ? value : false
    }
    return valueResult
  }

  onChangeExciseTaxRate = (value) => {
    this.props.onChangeExciseTaxRate(value)
  }

  render() {
    const { data, editMode, isNonCannabis, isNalTaxesOnly, dataExciseTax, surchargeExciseTaxFlag } =
      this.props

    const { excise, nonCannabis } = this.state
    const { nonCannabisTaxInfo = {} } = data
    return (
      <Paper className="paper-page">
        <ListItem>
          <Grid container>
            <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
              {`Includes ${!isNonCannabis ? 'California' + ' ' + excise : nonCannabis}`}
            </Grid>
            <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
              <EditableSwitch
                valueToRender={
                  !isNonCannabis
                    ? data.enableExciseTax
                      ? 'Enabled'
                      : 'Disabled'
                    : data.enableNonCannabisTax
                    ? 'Enabled'
                    : 'Disabled'
                }
                checked={!isNonCannabis ? data.enableExciseTax : data.enableNonCannabisTax}
                editMode={editMode}
                onChange={this.onChangeExcise(
                  !isNonCannabis ? 'enableExciseTax' : 'enableNonCannabisTax',
                  true,
                )}
              />
            </Grid>
            <Grid className="editField" item xs={12} sm={4} md={4} lg={5}>
              <span>
                {' '}
                {`When enabled, ${
                  !isNonCannabis ? excise : nonCannabis
                } parameters for the shop can be updated including wholesale transfers/orders.`}
              </span>
            </Grid>
          </Grid>
        </ListItem>
        {(!isNonCannabis && data.enableExciseTax) ||
        (isNonCannabis && data.enableNonCannabisTax) ? (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {!isNonCannabis ? (
              <Fragment>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      <span>{`Do you want to include Excise Tax as a line item in the customers receipt?`}</span>
                    </Grid>
                    <Grid className="full-width pull-left" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSwitch
                        valueToRender={
                          !isNonCannabis
                            ? data.exciseTaxType === 'PER_ITEM'
                              ? 'Enabled'
                              : 'Disabled'
                            : data.nonCannabisType === 'PER_ITEM'
                            ? 'Enabled'
                            : 'Disabled'
                        }
                        checked={
                          !isNonCannabis
                            ? data.exciseTaxType === 'PER_ITEM'
                            : data.nonCannabisType === 'PER_ITEM'
                        }
                        editMode={editMode}
                        onChange={this.onChangeExciseType(
                          !isNonCannabis ? 'exciseTaxType' : 'nonCannabisType',
                          'PER_ITEM',
                        )}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="text-center" item xs={12} sm={12} md={12} lg={12}>
                      <span className="text-bold">OR</span>
                    </Grid>
                  </Grid>
                </ListItem>
                <ListItem>
                  <Grid container>
                    <Grid className="labelField" item xs={12} sm={6} md={6} lg={6}>
                      <span>
                        Do you want receipt to include{' '}
                        {`"The  ${
                          !isNonCannabis ? `cannabis ${excise}` : nonCannabis
                        }es are included in the total amount of this invoice."`}
                      </span>
                    </Grid>
                    <Grid className="full-width pull-left" item xs={12} sm={6} md={6} lg={6}>
                      <EditableSwitch
                        valueToRender={
                          !isNonCannabis
                            ? data.exciseTaxType === 'TOTAL_AMOUNT'
                              ? 'Enabled'
                              : 'Disabled'
                            : data.nonCannabisType === 'TOTAL_AMOUNT'
                            ? 'Enabled'
                            : 'Disabled'
                        }
                        checked={
                          !isNonCannabis
                            ? data.exciseTaxType === 'TOTAL_AMOUNT'
                            : data.nonCannabisType === 'TOTAL_AMOUNT'
                        }
                        editMode={editMode}
                        onChange={this.onChangeExciseType(
                          !isNonCannabis ? 'exciseTaxType' : 'nonCannabisType',
                          'TOTAL_AMOUNT',
                        )}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                {!isNalTaxesOnly && (
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        State Mark Up (Arm's Length){' '}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <div className="full-width pull-left">
                          <div className="codeBlockWidth code">{`${
                            !isNonCannabis
                              ? (data.exciseTaxInfo && data.exciseTaxInfo.stateMarkUp) || 60
                              : (nonCannabisTaxInfo && nonCannabisTaxInfo.stateMarkUp) || 60
                          }%`}</div>
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
                <ListItem>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      State {!isNonCannabis ? excise : nonCannabis}
                    </Grid>
                    <Grid item xs={1} sm={1} md={1} lg={1}>
                      <EditableNumericInput
                        placeholder="Excise Tax"
                        className="numeric-material-input"
                        mobile={false}
                        valueToRender={toPercentage(
                          !isNonCannabis
                            ? (data.exciseTaxInfo && data.exciseTaxInfo.exciseTax) || 0
                            : (nonCannabisTaxInfo && nonCannabisTaxInfo.exciseTax) || 0,
                        )}
                        value={convertToFixed(
                          !isNonCannabis
                            ? (data.exciseTaxInfo && data.exciseTaxInfo.exciseTax) || 0
                            : (nonCannabisTaxInfo && nonCannabisTaxInfo.exciseTax) || 0,
                          2,
                        )}
                        onChange={this.onChangeExciseTaxRate}
                        min={0}
                        strict
                        precision={2}
                        editMode={editMode}
                        onKeyDown={onKeyDown}
                      />
                    </Grid>
                  </Grid>
                </ListItem>
                {!isNalTaxesOnly && (
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        Non-Arms Length on Retail Price
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.nalExciseFromRetailCost ? 'Enabled' : 'Disabled'}
                          checked={data.nalExciseFromRetailCost}
                          editMode={editMode}
                          onChange={this.onChange('nalExciseFromRetailCost', true)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={5}>
                        <div className="full-width pull-left">
                          <div>
                            When enabled, NAL {!isNonCannabis ? excise : nonCannabis} would be
                            calculated on original retail price. If disabled, it will calculated
                            based on retail price after discounts.
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
                <ListItem>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      {isNalTaxesOnly
                        ? 'Calculate Excise Tax after City Tax'
                        : 'Calculate Non-Arms Length tax after City tax'}
                    </Grid>
                    <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                      <EditableSwitch
                        valueToRender={data.nalExciseAfterCityTax ? 'Enabled' : 'Disabled'}
                        checked={data.nalExciseAfterCityTax}
                        editMode={editMode}
                        onChange={this.onChangeExcise('nalExciseAfterCityTax', true)}
                      />
                    </Grid>
                    <Grid containeritem xs={12} sm={4} md={4} lg={5}>
                      <Grid xs={11}>
                        <div className="full-width pull-left">
                          <div>
                            {isNalTaxesOnly
                              ? 'When enabled, Excise Tax will be calculated after City tax.'
                              : `When enabled, NAL ${
                                  !isNonCannabis ? excise : nonCannabis
                                } will be calculated after City tax.`}
                          </div>
                        </div>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-end',
                          fontSize: '14px',
                        }}
                      >
                        <HtmlTooltip
                          placement="top-center"
                          title={`If “Calculate Non-Arms Length tax after City tax" is enabled, and Non-Arm's Length excise tax is set to pretax, then you must also set the city tax to pretax in order to calculate taxes properly.`}
                        >
                          <InfoIcon style={{ color: '#03a9f4' }} />
                        </HtmlTooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                </ListItem>
                {false && data.nalExciseAfterCityTax === true && (
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {'Calculate delivery fee tax before excise tax'}
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={
                            this.getValueToRender(
                              dataExciseTax && dataExciseTax.enableDeliveryFeeBeforeExciseTax,
                            )
                              ? 'Enabled'
                              : 'Disabled'
                          }
                          checked={this.getValueToRender(
                            dataExciseTax && dataExciseTax.enableDeliveryFeeBeforeExciseTax,
                          )}
                          editMode={editMode}
                          onChange={this.onChange('enableDeliveryFeeBeforeExciseTax', true)}
                        />
                      </Grid>
                      <Grid containeritem xs={12} sm={4} md={4} lg={5}>
                        <Grid xs={11}>
                          <div className="full-width pull-left">
                            <div>
                              {
                                'When enabled, City tax includes delivery fee tax before excise tax.'
                              }
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
                {false && data.nalExciseAfterCityTax === true && surchargeExciseTaxFlag && (
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {'Calculate surcharge fee tax before excise tax'}
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={
                            this.getValueToRender(
                              dataExciseTax && dataExciseTax.enableSurchargeFeeBeforeExciseTax,
                            )
                              ? 'Enabled'
                              : 'Disabled'
                          }
                          checked={this.getValueToRender(
                            dataExciseTax && dataExciseTax.enableSurchargeFeeBeforeExciseTax,
                          )}
                          editMode={editMode}
                          onChange={this.onChange('enableSurchargeFeeBeforeExciseTax', true)}
                        />
                      </Grid>
                      <Grid containeritem xs={12} sm={4} md={4} lg={5}>
                        <Grid xs={11}>
                          <div className="full-width pull-left">
                            <div>
                              {
                                'When enabled, City tax includes surcharge fee tax before excise tax.'
                              }
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
                {!isNalTaxesOnly && (
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        Arms Length Zero Price
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={data.alExciseOnZeroPrice ? 'Enabled' : 'Disabled'}
                          checked={data.alExciseOnZeroPrice}
                          editMode={editMode}
                          onChange={this.onChange('alExciseOnZeroPrice', true)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={5}>
                        <div className="full-width pull-left">
                          <div>
                            When enabled, arms length {!isNonCannabis ? excise : nonCannabis} will
                            calculate even if final price is zero (after discounts).
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
                <ListItem>
                  <Grid container>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      Product prices include {!isNonCannabis ? excise : nonCannabis} - Default
                    </Grid>
                    <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                      <EditableSwitch
                        valueToRender={data.productPriceIncludeExciseTax ? 'Enabled' : 'Disabled'}
                        checked={data.productPriceIncludeExciseTax}
                        editMode={editMode}
                        onChange={this.onChange('productPriceIncludeExciseTax', true)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4} lg={5}>
                      <div className="full-width pull-left">
                        <div>
                          When enabled, new products will have prices include{' '}
                          {!isNonCannabis ? excise : nonCannabis} pre-enabled.
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </ListItem>
                {surchargeExciseTaxFlag && (
                  <ListItem>
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        Surcharge Fee subjected to Excise Tax
                      </Grid>
                      <Grid className="editField" item xs={12} sm={2} md={2} lg={1}>
                        <EditableSwitch
                          valueToRender={
                            this.getValueToRender(
                              dataExciseTax && dataExciseTax.enableSurchargeTaxExciseTax,
                            )
                              ? 'Enabled'
                              : 'Disabled'
                          }
                          checked={this.getValueToRender(
                            dataExciseTax && dataExciseTax.enableSurchargeTaxExciseTax,
                          )}
                          editMode={editMode}
                          onChange={this.onChange('enableSurchargeTaxExciseTax', true)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4} lg={5}>
                        <div className="full-width pull-left">
                          <div>When enabled, Surcharge Fee subjected to Excise Tax</div>
                        </div>
                      </Grid>
                    </Grid>
                  </ListItem>
                )}
              </Fragment>
            ) : null}
          </Grid>
        ) : null}
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxOption/ExciseTaxOption.js